module.exports = __webpack_public_path__ + "img/mode1.d8f103ae.png";